import { getApiUrl } from '../../../Url';

const getEndpointUrl = (stationId: string) =>
  getApiUrl({
    path: `stations/webStationId:${stationId}/adCategoryExclusions`,
  });

type AdCategoryExclusionParameters = {
  webStationId: string;
};

export type FetchAdCategoryExclusionsResponse = string[];

export async function fetchAdCategoryExclusions({
  webStationId,
}: AdCategoryExclusionParameters): Promise<FetchAdCategoryExclusionsResponse> {
  const url = getEndpointUrl(webStationId);
  try {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (response.ok) {
      return response.json();
    }
    throw new Error(
      `Unable to fetch Ad Category exclusions for ${webStationId}`
    );
  } catch (err) {
    throw new Error(err.message);
  }
}
